import data from "../../../../../src/DataTable/DataTable.docs.json";
import * as React from 'react';
export default {
  data,
  React
};